

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { useAuth } from '../../context/AuthContext';
import BottomNav from '../../components/layout/BottomNav';

const G     = '#1A6B3C';
const LIGHT = '#EAF3DE';

const CATEGORY_ICON = {
  vegetables:'🥦', fruits:'🍎', 'leafy greens':'', herbs:'', pulses:'🫘',
  grains:'', spices:'🧄', flowers:'🌸', mushrooms:'🍄', other:'',
};

function greeting() {
  const h = new Date().getHours();
  if (h < 12) return 'Good Morning';
  if (h < 17) return 'Good Afternoon';
  return 'Good Evening';
}

export default function BuyerDashboardPage() {
  const { user }   = useAuth();
  const navigate   = useNavigate();

  const [tab,          setTab]          = useState('ready');
  const [readyCrops,   setReadyCrops]   = useState([]);
  const [myRequests,   setMyRequests]   = useState([]);
  const [farmers,      setFarmers]      = useState([]);
  const [orders,       setOrders]       = useState([]);
  const [readyFilter,  setReadyFilter]  = useState({ category:'', location:'' });
  const [readyLoading, setReadyLoading] = useState(false);
  const [loading,      setLoading]      = useState(true);
  const [search,       setSearch]       = useState('');
  const [categories,   setCategories]   = useState([]);
  const [showFilters,  setShowFilters]  = useState(false);

  useEffect(() => { loadAll(); loadCategories(); }, []);

  const loadAll = async () => {
    setLoading(true);
    const [rc, my, f, ord] = await Promise.allSettled([
      api.get('/crops/ready?limit=20'),
      api.get('/requests/my?status=open'),
      api.get('/users/farmers?limit=30'),
      api.get('/orders/my'),
    ]);
    setReadyCrops(rc.value?.data?.crops     || []);
    setMyRequests(my.value?.data?.requests  || []);
    setFarmers(f.value?.data?.farmers       || []);
    setOrders(ord.value?.data?.orders       || []);
    setLoading(false);
  };

  const loadCategories = async () => {
    try {
      const { data } = await api.get('/categories');
      setCategories((data.categories || []).filter(c => c.isActive));
    } catch {}
  };

  const loadReadyCrops = async (filters = readyFilter) => {
    setReadyLoading(true);
    try {
      const params = new URLSearchParams({ limit: 20 });
      if (filters.category) params.set('category', filters.category);
      if (filters.location) params.set('location', filters.location);
      const { data } = await api.get('/crops/ready?' + params);
      setReadyCrops(data.crops || []);
    } catch {} finally { setReadyLoading(false); }
  };

  const updateReadyFilter = (key, val) => {
    const updated = { ...readyFilter, [key]: val };
    setReadyFilter(updated);
    loadReadyCrops(updated);
  };

  const filterList = (list) => {
    if (!search) return list;
    return list.filter(u =>
      u.name?.toLowerCase().includes(search.toLowerCase()) ||
      u.locationAddress?.toLowerCase().includes(search.toLowerCase()) ||
      u.mobile?.includes(search)
    );
  };

  const prefs = user?.cropPreferences;
  const hasPrefs = prefs?.categories?.length > 0 || prefs?.subCategories?.length > 0;

  const visibleReadyCrops = readyCrops.filter(c => !search ||
    c.cropName?.toLowerCase().includes(search.toLowerCase()) ||
    c.userId?.name?.toLowerCase().includes(search.toLowerCase()) ||
    c.locationAddress?.toLowerCase().includes(search.toLowerCase()));

  const STATS = [
    { id:'ready',      value:readyCrops.length, label:'Ready',   bg:LIGHT,      color:G,        icon:'' },
    { id:'myrequests', value:myRequests.length, label:'Requests',bg:'#FEF3E2',  color:'#B45309',icon:'📋' },
    { id:'farmers',    value:farmers.length,    label:'Farmers', bg:'#E6F0FF',  color:'#1D4ED8',icon:'👥' },
    { id:'orders',     value:orders.length,     label:'Orders',  bg:'#F3E8FF',  color:'#7C3AED',icon:'🧺' },
  ];

  return (
    <div style={{ background:'#F5F7FA', minHeight:'100vh', fontFamily:'Inter,system-ui,sans-serif', paddingBottom:90 }}>
      <style>{`
        @keyframes buyerSpin { to { transform: rotate(360deg); } }
      `}</style>

      {/* ── Header ── */}
      <div style={{ background:G, padding:'16px 16px 20px', borderBottomLeftRadius:22, borderBottomRightRadius:22 }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <div>
            <div style={{ fontSize:13, color:'rgba(255,255,255,.85)', display:'flex', alignItems:'center', gap:6 }}>
              {/* {greeting()}, {user?.name?.split(' ')[0] || 'there'}!  */}
            </div>
            <div style={{ fontSize:19, fontWeight:800, color:'white', marginTop:2 }}>Buyer Dashboard</div>
            <div style={{ fontSize:12, color:'rgba(255,255,255,.75)', marginTop:2 }}>Fresh crops, direct from farmers</div>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <button onClick={() => navigate('/notifications')}
              style={{ position:'relative', width:36, height:36, borderRadius:'50%', background:'rgba(255,255,255,.18)', border:'1px solid rgba(255,255,255,.25)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:15, cursor:'pointer' }}>
              🔔
            </button>
            <div onClick={() => navigate('/profile')}
              style={{ width:40, height:40, borderRadius:'50%', background:'rgba(255,255,255,.25)', border:'2px solid rgba(255,255,255,.4)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:15, color:'white', fontWeight:700, cursor:'pointer' }}>
              {user?.name?.[0]?.toUpperCase() || 'U'}
            </div>
          </div>
        </div>

        {/* Stat cards */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(4, minmax(0,1fr))', gap:8, marginTop:16 }}>
          {STATS.map(s => (
            <div key={s.id}
              onClick={() => s.id === 'orders' ? navigate('/orders') : (setTab(s.id), setSearch(''))}
              style={{ background:s.bg, borderRadius:12, padding:'10px 6px', textAlign:'center', cursor:'pointer',
                border: tab===s.id && s.id!=='orders' ? `2px solid ${s.color}` : '2px solid transparent' }}>
              <div style={{ fontSize:16 }}>{s.icon}</div>
              <div style={{ fontSize:17, fontWeight:800, color:s.color, marginTop:2 }}>{String(s.value).padStart(2,'0')}</div>
              <div style={{ fontSize:10, fontWeight:600, color:s.color }}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Search + Filters ── */}
      <div style={{ padding:'14px 14px 0', display:'flex', gap:8 }}>
        <div style={{ flex:1, background:'white', borderRadius:20, padding:'9px 14px', display:'flex', alignItems:'center', gap:8, border:'0.5px solid #E5E7EB' }}>
          <span style={{ fontSize:14, color:'#9CA3AF' }}>🔍</span>
          <input
            placeholder={tab==='ready' ? 'Search crops, category or farmer...' : tab==='myrequests' ? 'Search requests...' : 'Search farmers...'}
            value={search} onChange={e => setSearch(e.target.value)}
            style={{ flex:1, border:'none', outline:'none', fontSize:13, background:'transparent' }} />
        </div>
        <button onClick={() => setShowFilters(v => !v)}
          style={{ background:G, color:'white', border:'none', borderRadius:40, padding:'0 10px', fontSize:10.5, fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', gap:6 }}>
          ☰ Filters
        </button>
      </div>

      {/* Category chips */}
      {tab === 'ready' && (
        <div style={{ display:'flex', gap:8, padding:'12px 14px 0', overflowX:'auto', scrollbarWidth:'none' }}>
          <button onClick={() => updateReadyFilter('category', '')}
            style={{ flexShrink:0, display:'flex', flexDirection:'row', alignItems:'center', gap:6, padding:'7px 8px', borderRadius:999,
              border:'none', background: !readyFilter.category ? G : 'white', color: !readyFilter.category ? 'white' : '#374151',
              fontSize:10.5, fontWeight:700, cursor:'pointer', boxShadow:'0 1px 4px rgba(0,0,0,.06)', whiteSpace:'nowrap' }}>
            <span style={{ fontSize:14 }}></span> All
          </button>
          {categories.map(c => {
            const active = readyFilter.category === c.name.toLowerCase();
            return (
              <button key={c._id} onClick={() => updateReadyFilter('category', active ? '' : c.name.toLowerCase())}
                style={{ flexShrink:0, display:'flex', flexDirection:'row', alignItems:'center', gap:2, padding:'7px 10px', borderRadius:999,
                  border:'none', background: active ? G : 'white', color: active ? 'white' : '#374151',
                  fontSize:10.5, fontWeight:700, cursor:'pointer', boxShadow:'0 1px 4px rgba(0,0,0,.06)', whiteSpace:'nowrap' }}>
                {(c.icon || CATEGORY_ICON[c.name?.toLowerCase()]) && <span style={{ fontSize:14 }}>{c.icon || CATEGORY_ICON[c.name?.toLowerCase()]}</span>} {c.name}
              </button>
            );
          })}
        </div>
      )}

      {/* Extra filters panel (location + clear) */}
      {showFilters && tab === 'ready' && (
        <div style={{ padding:'10px 14px 0', display:'flex', gap:8 }}>
          <input
            placeholder=" Location..."
            value={readyFilter.location}
            onChange={e => updateReadyFilter('location', e.target.value)}
            style={{ flex:1, background:'white', border:'0.5px solid #E5E7EB', borderRadius:12, padding:'9px 12px', fontSize:12.5, outline:'none' }} />
          {(readyFilter.category || readyFilter.location) && (
            <button onClick={() => { setReadyFilter({ category:'', location:'' }); loadReadyCrops({ category:'', location:'' }); }}
              style={{ background:'white', border:'1px solid #E5E7EB', borderRadius:12, padding:'0 14px', fontSize:12, fontWeight:600, color:'#6B7280', cursor:'pointer' }}>
              ✕ Clear
            </button>
          )}
        </div>
      )}

      {/* Preferences banner */}
      {tab==='ready' && hasPrefs && !readyFilter.category && !readyFilter.location && (
        <div style={{ margin:'12px 14px 0', background:LIGHT, border:'1px solid #BBF7D0', borderRadius:12, padding:'10px 14px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div style={{ fontSize:12, color:'#065F46' }}>🎯 Filtered by your preferences</div>
          <button onClick={() => navigate('/profile')}
            style={{ fontSize:11, color:G, background:'white', border:`1px solid ${G}`, borderRadius:20, padding:'3px 10px', cursor:'pointer' }}>Edit</button>
        </div>
      )}

      {/* ── Hero banner ── */}
      {tab === 'ready' && (
        <div style={{ padding:'14px 14px 0' }}>
          <div style={{ background:LIGHT, borderRadius:18, position:'relative', overflow:'hidden', minHeight:150 }}>
            {/* Background image — swap this src for your own banner photo */}
            <img
              src="/images/buyer-banner.png"
              alt=""
              style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover' }}
              onError={e => { e.target.style.display='none'; }}
            />
            <div style={{ position:'relative', zIndex:1, maxWidth:'65%', padding:18 }}>
              <div style={{ fontSize:12, color:'#3E8E4F', fontWeight:600, marginBottom:4 }}></div>
              <div style={{ fontSize:19, fontWeight:800, color:'#1a1a1a', lineHeight:1.3 }}>
               
              </div>
              <div style={{ fontSize:12, color:'#4B5D4F', margin:'8px 0 14px' }}></div>
              
            </div>
          </div>
        </div>
      )}

      <div style={{ maxWidth:480, margin:'0 auto', padding:'16px 14px 0' }}>
        {loading ? (
          <div style={{ display:'flex', justifyContent:'center', padding:50 }}>
            <div style={{ width:32, height:32, border:'3px solid #E5E7EB', borderTopColor:G, borderRadius:'50%', animation:'buyerSpin 0.8s linear infinite' }} />
          </div>
        ) : (
          <>
            {/* ── READY TO BUY TAB ── */}
            {tab === 'ready' && (
              <>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
                  <span style={{ fontSize:16, fontWeight:800, color:'#1a1a1a' }}>Crops Near You</span>
                  <button onClick={() => navigate('/marketplace')}
                    style={{ background:'none', border:'none', color:G, fontSize:12.5, fontWeight:700, cursor:'pointer' }}>
                    View all →
                  </button>
                </div>

                {readyLoading ? (
                  <div style={{ display:'flex', justifyContent:'center', padding:30 }}>
                    <div style={{ width:26, height:26, border:'3px solid #E5E7EB', borderTopColor:G, borderRadius:'50%', animation:'buyerSpin 0.8s linear infinite' }} />
                  </div>
                ) : (
                  <>
                    {visibleReadyCrops.map(crop => {
                      const stage = crop.latestStage || crop.stages?.[crop.stages?.length - 1];
                      const thumb = stage?.mediaUrls?.find(u => u && !u.startsWith('data:'));
                      const farmerName = crop.userId?.name || 'Farmer';
                      return (
                        <div key={crop._id}
                          style={{ background:'white', borderRadius:16, border:'0.5px solid #E5E7EB', boxShadow:'0 2px 8px rgba(0,0,0,.05)', marginBottom:14, overflow:'hidden', cursor:'pointer' }}
                          onClick={() => navigate(`/crop/${crop._id}`)}>
                          <div style={{ width:'100%', height:140, background:LIGHT, position:'relative', overflow:'hidden' }}>
                            {thumb
                              ? <img src={thumb} alt={crop.cropName} style={{ width:'100%', height:'100%', objectFit:'cover', objectPosition:'center' }} />
                              : null}
                          </div>
                          <div style={{ padding:'10px 14px' }}>
                            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                              <div style={{ minWidth:0, flex:1 }}>
                                <div style={{ fontWeight:700, fontSize:15, color:'#1a1a1a', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{crop.cropName}</div>
                                <div style={{ fontSize:12, color:'#9CA3AF', textTransform:'capitalize', marginTop:2, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                                {crop.category} · {crop.subCategory}
                                </div>
                              </div>
                              <span style={{ background:'#DCFCE7', color:'#166534', fontSize:10.5, fontWeight:700, padding:'4px 10px', borderRadius:20, flexShrink:0, marginLeft:8, whiteSpace:'nowrap' }}>
                                In Stock
                              </span>
                            </div>
                            <div style={{ fontSize:12, color:'#6B7280', marginTop:6, display:'flex', alignItems:'center', gap:12, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                              <span>{farmerName}</span>
                              <span style={{ display:'flex', alignItems:'center', gap:3, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                                 {(crop.userId?.locationAddress || crop.locationAddress || '—')}
                              </span>
                            </div>
                            <div style={{ fontSize:13, color:G, fontWeight:700, marginTop:6, display: crop.price ? 'block' : 'none' }}>
                                {crop.price ? `₹${crop.price} / ${crop.priceUnit?.replace('per_','') || 'unit'}` : ' '}
                              </div>
                            <div style={{ display:'none' }}>
                              <div style={{ display:'flex', alignItems:'center', gap:6, margin:'10px 0 12px' }}>
                                {crop.userId?.photo || crop.userId?.avatar || crop.userId?.profileImage ? (
                                  <img
                                    src={crop.userId.photo || crop.userId.avatar || crop.userId.profileImage}
                                    alt={farmerName}
                                    style={{ width:24, height:24, borderRadius:'50%', objectFit:'cover', flexShrink:0 }}
                                    onError={e => { e.target.style.display='none'; e.target.nextSibling.style.display='flex'; }}
                                  />
                                ) : null}
                                <div style={{
                                  width:24, height:24, borderRadius:'50%', background:G, color:'white', fontSize:10.5, fontWeight:700,
                                  display: (crop.userId?.photo || crop.userId?.avatar || crop.userId?.profileImage) ? 'none' : 'flex',
                                  alignItems:'center', justifyContent:'center', flexShrink:0,
                                }}>
                                  {farmerName[0]?.toUpperCase()}
                                </div>
                                <span style={{ fontSize:12, fontWeight:600, color:'#374151', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{farmerName}</span>
                                {crop.userId?.rating && (
                                  <span style={{ background:G, color:'white', fontSize:10, fontWeight:700, padding:'3px 8px', borderRadius:10, display:'flex', alignItems:'center', gap:3, flexShrink:0 }}>
                                    ★ {crop.userId.rating}
                                  </span>
                                )}
                              </div>
                            </div>
                              <div style={{ display:'flex', gap:8, marginTop:10 }}>
                                <button onClick={e => { e.stopPropagation(); navigate(`/crop/${crop._id}`); }}
                                  style={{ flex:1, background:G, border:'none', color:'white', borderRadius:10, padding:'9px 8px', fontSize:12.5, fontWeight:700, cursor:'pointer' }}>
                                  👁 View Crop
                                </button>
                                <a href={`tel:+91${crop.userId?.mobile}`} onClick={e => e.stopPropagation()}
                                  style={{ flex:1, background:'white', color:G, border:`1.5px solid ${G}`, borderRadius:10, padding:'9px 8px', fontSize:12.5, fontWeight:700, cursor:'pointer', textAlign:'center', textDecoration:'none' }}>
                                  📞 Call Farmer
                                </a>
                              </div>
                            </div>
                          </div>
                        );
                    })}
                    {visibleReadyCrops.length === 0 && (
                      <div style={{ textAlign:'center', padding:'40px 20px', color:'#9CA3AF' }}>
                        <div style={{ fontSize:40, marginBottom:10 }}></div>
                        <div style={{ fontSize:14, fontWeight:600, color:'#4B5D4F' }}>No crops ready to buy</div>
                        <button onClick={() => navigate('/requests/new')}
                          style={{ marginTop:14, background:G, color:'white', border:'none', borderRadius:20, padding:'10px 20px', fontSize:12.5, fontWeight:700, cursor:'pointer' }}>
                          📦 Create Request
                        </button>
                      </div>
                    )}
                  </>
                )}

                {/* Bottom shortcuts */}
                <div style={{ display:'grid', gridTemplateColumns:'repeat(3, minmax(0,1fr))', gap:10, margin:'22px 0' }}>
                  <div onClick={() => setTab('myrequests')} style={{ position:'relative', background:LIGHT, borderRadius:14, padding:'14px 8px', textAlign:'center', cursor:'pointer' }}>
                    {myRequests.length > 0 && (
                      <span style={{ position:'absolute', top:6, right:8, background:G, color:'white', fontSize:9, fontWeight:700, width:16, height:16, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center' }}>{myRequests.length}</span>
                    )}
                    <div style={{ fontSize:20 }}>📋</div>
                    <div style={{ fontSize:11.5, fontWeight:700, color:'#1a1a1a', marginTop:4 }}>My Requests</div>
                    <div style={{ fontSize:9.5, color:'#6B7280' }}>Track your crop requests</div>
                  </div>
                  <div onClick={() => navigate('/add-crop')} style={{ background:LIGHT, borderRadius:14, padding:'14px 8px', textAlign:'center', cursor:'pointer' }}>
                    <div style={{ fontSize:20 }}>🧺</div>
                    <div style={{ fontSize:11.5, fontWeight:700, color:'#1a1a1a', marginTop:4 }}>Add Your Crop</div>
                    <div style={{ fontSize:9.5, color:'#6B7280' }}>List your crop & reach buyers</div>
                  </div>
                  <div onClick={() => setTab('farmers')} style={{ background:LIGHT, borderRadius:14, padding:'14px 8px', textAlign:'center', cursor:'pointer' }}>
                    <div style={{ fontSize:20 }}>👥</div>
                    <div style={{ fontSize:11.5, fontWeight:700, color:'#1a1a1a', marginTop:4 }}>Top Farmers</div>
                    <div style={{ fontSize:9.5, color:'#6B7280' }}>Connect with trusted farmers</div>
                  </div>
                </div>

                {/* Footer banner */}
                <div onClick={() => navigate('/farmers')}
                  style={{ background:LIGHT, borderRadius:16, position:'relative', overflow:'hidden', cursor:'pointer', marginBottom:20 }}>
                  {/* Background image — swap this src for your own footer banner photo */}
                  <img
                    src="/images/footer-banner.png"
                    alt=""
                    style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover' }}
                    onError={e => { e.target.style.display='none'; }}
                  />
                  {/* Overlay so text stays readable over the photo */}
                  <div style={{ position:'absolute', inset:0, background:'linear-gradient(90deg, rgba(255,255,255,.92) 0%, rgba(255,255,255,.75) 55%, rgba(255,255,255,.15) 100%)' }} />

                  <div style={{ position:'relative', zIndex:1, padding:'14px 16px', display:'flex', alignItems:'center', gap:12 }}>
                    <span style={{ fontSize:22 }}></span>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:13, fontWeight:700, color:'#1a1a1a' }}>Go Direct. Eat Fresh. Live Healthy.</div>
                      <div style={{ fontSize:11, color:'#4B5D4F', marginTop:2 }}>Support local farmers and get the best quality crops delivered to you.</div>
                    </div>
                    <span style={{ fontSize:18, color:G }}>›</span>
                  </div>
                </div>
              </>
            )}

            {/* ── MY REQUESTS TAB ── */}
            {tab === 'myrequests' && (
              <>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:12 }}>
                  <span style={{ fontSize:13, color:'#9CA3AF' }}>{myRequests.length} open requests</span>
                  <button onClick={() => navigate('/requests/new')}
                    style={{ background:G, color:'white', border:'none', borderRadius:16, padding:'6px 14px', fontSize:12, fontWeight:700, cursor:'pointer' }}>+ New</button>
                </div>
                {myRequests
                  .filter(r => !search ||
                    r.cropName?.toLowerCase().includes(search.toLowerCase()) ||
                    r.preferredLocation?.toLowerCase().includes(search.toLowerCase()))
                  .map(req => (
                    <div key={req._id} style={{ background:'white', borderRadius:14, border:'0.5px solid #E5E7EB', padding:'12px 14px', marginBottom:10, borderLeft:'4px solid #F59E0B' }}>
                      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:6 }}>
                        <div>
                          <div style={{ fontWeight:700, fontSize:15, color:'#1a1a1a' }}>{req.cropName}</div>
                          <div style={{ fontSize:12.5, color:'#6B7280' }}>
                            ⚖️ {req.quantity} {req.quantityUnit}
                            {req.offeredPrice && <span style={{ color:G, fontWeight:700, marginLeft:6 }}>₹{req.offeredPrice}/{req.offeredPriceUnit?.replace('per_','')}</span>}
                          </div>
                        </div>
                        <span style={{ background:'#FEF3C7', color:'#D97706', borderRadius:20, padding:'3px 10px', fontSize:11, fontWeight:700 }}>Open</span>
                      </div>
                      <div style={{ fontSize:12, color:'#6B7280' }}> {req.preferredLocation || '—'}</div>
                      <div style={{ fontSize:11, color:'#9CA3AF', marginTop:2 }}>
                        🕐 {new Date(req.createdAt).toLocaleDateString('en-IN', { day:'numeric', month:'short', year:'numeric' })}
                      </div>
                      {req.notes && <div style={{ fontSize:12, color:'#6B7280', fontStyle:'italic', marginTop:4 }}>"{req.notes}"</div>}
                    </div>
                  ))
                }
                {myRequests.length === 0 && (
                  <div style={{ textAlign:'center', padding:30, color:'#9CA3AF' }}>
                    <div style={{ fontSize:32, marginBottom:8 }}>📋</div>
                    <div>No open requests</div>
                    <button onClick={() => navigate('/requests/new')}
                      style={{ marginTop:12, background:G, color:'white', border:'none', borderRadius:20, padding:'10px 20px', fontSize:12.5, fontWeight:700, cursor:'pointer' }}>
                      + Create Request
                    </button>
                  </div>
                )}
              </>
            )}

            {/* ── FARMERS TAB ── */}
            {tab === 'farmers' && (
              <>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
                  <span style={{ fontSize:13, color:'#9CA3AF' }}>{filterList(farmers).length} farmers</span>
                  <button onClick={() => navigate('/marketplace')}
                    style={{ background:'white', color:G, border:`1.5px solid ${G}`, borderRadius:16, padding:'6px 14px', fontSize:12, fontWeight:700, cursor:'pointer' }}>🛒 Marketplace</button>
                </div>
                {filterList(farmers).map(f => (
                  <div key={f._id} style={{ background:'white', borderRadius:14, border:'0.5px solid #E5E7EB', padding:'12px 14px', marginBottom:10, display:'flex', alignItems:'center', gap:10 }}>
                    <div style={{ width:44, height:44, borderRadius:'50%', background:G, color:'white', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:700, fontSize:18, flexShrink:0 }}>
                      {f.name?.[0] || 'F'}
                    </div>
                    <div style={{ flex:1, cursor:'pointer', minWidth:0 }} onClick={() => navigate(`/farmer/${f._id}`)}>
                      <div style={{ fontWeight:700, fontSize:14, color:'#1a1a1a' }}>{f.name}</div>
                      <div style={{ fontSize:12, color:'#9CA3AF', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                         {f.locationAddress || 'No location'}
                      </div>
                      <div style={{ fontSize:12, marginTop:2, color:'#374151' }}>
                         {f.cropCount||0} crops
                        {f.readyCount > 0 && <span style={{ color:G, marginLeft:8, fontWeight:700 }}>🟢 {f.readyCount} ready</span>}
                      </div>
                    </div>
                    <a href={`tel:+91${f.mobile}`} style={{ flexShrink:0, background:'white', border:`1.5px solid ${G}`, color:G, borderRadius:10, padding:'8px 10px', fontSize:14, textDecoration:'none' }}>📞</a>
                  </div>
                ))}
                {filterList(farmers).length === 0 && (
                  <div style={{ textAlign:'center', padding:30, color:'#9CA3AF' }}>No farmers found</div>
                )}
              </>
            )}
          </>
        )}
      </div>

      <BottomNav />
    </div>
  );
}